import { render, staticRenderFns } from "./PagesSection.vue?vue&type=template&id=6e2fb1fa"
import script from "./PagesSection.vue?vue&type=script&lang=js"
export * from "./PagesSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports